/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { TerminWiederholungsIntervall } from '@/domain/termine/shared/types/TerminWiederholungsIntervall';
import { Termin_WeekdayOccurrence } from '@/gql/graphql';
import dayjs from 'dayjs';
import { t } from 'i18next';

export function parseDate(
  value: string | undefined,
  selectedRepetition: string,
) {
  const date = value ? dayjs(value) : null;

  if (selectedRepetition === TerminWiederholungsIntervall.JAHR) {
    return {
      day: date?.date(),
      weekday: date?.format('dddd'),
      word: t('domain.termine.sheet.fields.im'),
      month: date?.format('MMMM'),
    };
  }
  return {
    day: date?.date(),
    weekday: date?.format('dddd'),
    word: t('domain.termine.sheet.fields.des'),
    month: t('domain.termine.sheet.fields.monats'),
  };
}

export enum TerminWeekdayOccurrence {
  FIXER_TAG = 'FIXER_TAG',
  ERSTER = 'ERSTER',
  ZWEITER = 'ZWEITER',
  DRITTER = 'DRITTER',
  VIERTER = 'VIERTER',
  LETZTER = 'LETZTER',
}

export function getWeekdayOccurrenceStringFromTerminWeekdayOccurrence(
  weekdayOccurrence: TerminWeekdayOccurrence | null,
  date: string | undefined,
  selectedRepetition: TerminWiederholungsIntervall,
  lowerCase?: boolean,
) {
  const { day, weekday, month, word } = parseDate(date, selectedRepetition);
  switch (weekdayOccurrence) {
    case TerminWeekdayOccurrence.FIXER_TAG:
      return t('domain.termine.sheet.fields.wochentagAuftreten.fixer_tag', {
        day: day,
        weekday: weekday,
        month: month,
        word: word,
      });
    case TerminWeekdayOccurrence.ERSTER:
      return lowerCase
        ? t('domain.termine.sheet.fields.wochentagAuftreten.erster_lowerCase', {
            weekday: weekday,
            month: month,
            word: word,
          })
        : t('domain.termine.sheet.fields.wochentagAuftreten.erster_upperCase', {
            weekday: weekday,
            month: month,
            word: word,
          });
    case TerminWeekdayOccurrence.ZWEITER:
      return lowerCase
        ? t(
            'domain.termine.sheet.fields.wochentagAuftreten.zweiter_lowerCase',
            {
              weekday: weekday,
              month: month,
              word: word,
            },
          )
        : t(
            'domain.termine.sheet.fields.wochentagAuftreten.zweiter_upperCase',
            {
              weekday: weekday,
              month: month,
              word: word,
            },
          );
    case TerminWeekdayOccurrence.DRITTER:
      return lowerCase
        ? t(
            'domain.termine.sheet.fields.wochentagAuftreten.dritter_lowerCase',
            {
              weekday: weekday,
              month: month,
              word: word,
            },
          )
        : t(
            'domain.termine.sheet.fields.wochentagAuftreten.dritter_upperCase',
            {
              weekday: weekday,
              month: month,
              word: word,
            },
          );
    case TerminWeekdayOccurrence.VIERTER:
      return lowerCase
        ? t(
            'domain.termine.sheet.fields.wochentagAuftreten.vierter_lowerCase',
            {
              weekday: weekday,
              month: month,
              word: word,
            },
          )
        : t(
            'domain.termine.sheet.fields.wochentagAuftreten.vierter_upperCase',
            {
              weekday: weekday,
              month: month,
              word: word,
            },
          );
    case TerminWeekdayOccurrence.LETZTER:
      return lowerCase
        ? t(
            'domain.termine.sheet.fields.wochentagAuftreten.letzter_lowerCase',
            {
              weekday: weekday,
              month: month,
              word: word,
            },
          )
        : t(
            'domain.termine.sheet.fields.wochentagAuftreten.letzter_upperCase',
            {
              weekday: weekday,
              month: month,
              word: word,
            },
          );

    default:
      return '';
  }
}

export const terminWeekdayOccurrenceToGraphQLMap: Record<
  TerminWeekdayOccurrence,
  Termin_WeekdayOccurrence
> = {
  [TerminWeekdayOccurrence.FIXER_TAG]: Termin_WeekdayOccurrence.FixerTag,
  [TerminWeekdayOccurrence.ERSTER]: Termin_WeekdayOccurrence.Erster,
  [TerminWeekdayOccurrence.ZWEITER]: Termin_WeekdayOccurrence.Zweiter,
  [TerminWeekdayOccurrence.DRITTER]: Termin_WeekdayOccurrence.Dritter,
  [TerminWeekdayOccurrence.VIERTER]: Termin_WeekdayOccurrence.Vierter,
  [TerminWeekdayOccurrence.LETZTER]: Termin_WeekdayOccurrence.Letzter,
} as const satisfies Record<TerminWeekdayOccurrence, Termin_WeekdayOccurrence>;
